module.exports = __webpack_public_path__ + "img/cloth_g3_pants-07.1a36306b.svg";